const data = {
	heroTag: "Agentic at Irish Titan",
	heroHeadingPart1: "Agentic Commerce",
	heroHeadingPart2: " is the engine.",
	heroHeadingPart3: "Your ",
	heroHeadingPart4: "Business",
	heroHeadingPart5: " is the Destination.",
	heroSub: "We use Agentic Commerce to amplify vibrant ecommerce strategy, facilitating execution and growth. That means that the focus stays on your business opportunity and the customer experience, driving results.",
	heroCtaPrimary: { label: "See Our Approach", href: "/approach" },
	heroCtaSecondary: { label: "Talk to a Titan", href: "/contact" },

	philosophyTag: "Our Philosophy",
	philosophyHeadingLine1: "The “Why” of AIs More Important",
	philosophyHeadingLine2: " Than the “How”.",
	philosophyDesc: "Every Agentic integration starts with a business problem, not a feature wishlist. That's the difference between AI that solves a real problem and one that sounds good in a pitch deck.",
	goldenCircleTag: "Golden Circle",
	goldenCircle: [
		{
			num: "01",
			tag: "The Purpose",
			heading: "Why do you do what you do?",
			body: "We start with the business problem first. AI should support a clear commercial goal, not be the goal itself.",
			featured: true,
		},
		{
			num: "02",
			tag: "The Method",
			heading: "How do we approach it?",
			body: "We define the strategy, the customer need, and the right process and governance before deciding where AI belongs.",
			featured: false,
		},
		{
			num: "03",
			tag: "The Outcome",
			heading: "What do we deliver?",
			body: "We build practical solutions that improve ecommerce performance, customer experience, and operational clarity.",
			featured: false,
		},
	],

	// Second Philosophy + Golden Circle block — different copy; highlights a different pillar.
	philosophy2Tag: "Our Agentic Pillars",
	philosophy2HeadingLine1: "Understanding",
	philosophy2HeadingLine2: "Agentic Commerce.",
	goldenCircle2: [
		{
			num: "01",
			tag: "",
			heading: "Data Enrichment",
			body: "Data is the currency of Agentic Commerce. Your data needs to be structured, streamlined, and ready for Agentic ingestion.",
			featured: true,
		},
		{
			num: "02",
			tag: "",
			heading: "Discovery",
			body: "A cornerstone of Consumer AI, much like Google before, consumers are searching for your products. Become discoverable where they’re searching.",
			featured: false,
		},
		{
			num: "03",
			tag: "",
			heading: "Checkout",
			body: "Will clicking an external link die off in the future? We don’t know. But we do know that people ARE purchasing through Agents right now. Are you prepared to process that new checkout channel?",
			featured: false,
		},
	],

	quote: "\"We take our craft seriously, but not ourselves.\"",
	quoteBody: "That same energy applies to Agentic Commerce. We're rigorous about outcomes and humble about hype. We celebrate wins as a team, own up to our mistakes and fix them fast, talk openly about what's working and why, and we always use clear and honest feedback as an act of trust, not punishment.",
	quoteAttribution: "— The Titan Way",

	pillarsTag: "Trust in AI",
	pillarsHeadingLine1: "Foundations for",
	pillarsHeadingLine2: "the Future.",
	pillarsDesc: "These principles keep the work clear, dependable, and aligned with business goals, now and for any AI we encounter in the future.",
	pillars: [
		{
			num: "01 — Transparency",
			heading: "No Surprises",
			body: "We clearly explain what AI tools are being used, where they are used, and why they are there. Nothing is hidden, we always live in the light.",
		},
		{
			num: "02 — Data Hygiene",
			heading: "Your Data Is Safe",
			body: "We check that your outgoing data is reliable, well structured, and protected before anything goes live.",
		},
		{
			num: "03 — Responsible Code",
			heading: "Built With Adaptability in Mind",
			body: "We build with the future in mind, so your systems can adapt as new needs and tools emerge.",
		},
		{
			num: "04 — Accountability",
			heading: "Healthy Feedback, Always",
			body: [
				{ text: "We believe " },
				{
					text: "good partnerships depend on honest feedback",
					href: "/healthy-accountability",
				},
				{
					text: ", shared responsibility, and trust. We work all around the same table, not through silos.",
				},
			],
		},
		{
			num: "05 — Relationships",
			heading: "Partnerships, Not Transactions",
			body: [
				{
					text: "Our work does not end at launch",
					href: "/partnerships-not-transactions",
				},
				{
					text: ". We stay involved and keep improving as your business grows.",
				},
			],
		},
		{
			num: "06 — Measurement",
			heading: "Success at the End",
			body: [
				{ text: "Success means the work " },
				{
					text: "delivered real value for your business",
					href: "/business-first-online-second",
				},
				{ text: ", not just that the technology is flashy." },
			],
		},
	],

	eduTag: "Education",
	eduHeadingLine1: "Where AI Adds Value",
	eduHeadingLine2: "in Ecommerce.",
	eduDesc: "AI can support both customer experience and internal execution, but the strongest value comes from practical use cases tied to commerce performance.",
	eduConsumer: {
		tag: "Consumer AI",
		heading: "Search Visibility and Customer Experience",
		lead: "On the consumer side, AI supports increased discovery, richer experiences, and better conversion across ecommerce channels.",
		items: [
			[
				{ text: "SEO, AEO, GEO, and GES", href: "/grow" },
				{ text: " improvements that help you be found" },
			],
			"More useful site search, personalization, recommendations, and navigation experiences",
			"Content and merchandising support that improves clarity and relevance",
			"Customer experiences that feel helpful, consistent, and brand-aligned",
		],
	},
	eduOperational: {
		tag: "Operational AI",
		heading: "Execution, Reporting, and Platform Capability",
		lead: "Internally, AI can help teams work more efficiently, improve reporting, and support new commerce capabilities without replacing human judgment.",
		items: [
			"Faster optimization and reporting for paid media and growth programs",
			"AI-focused data enrichment services across Build, Grow, or standalone work",
			"Agentic commerce experiences and capabilities built into platforms and surrounding tools",
			"Clear processes that keep decisions human and technology accountable",
		],
	},

	spectrumTag: "How We Decide",
	spectrumHeadingLine1: "Leading Edge.",
	spectrumHeadingLine2: "Not Bleeding Edge.",
	spectrumDesc:
		"We're not allergic to new technology. We're selective about it. There's a meaningful difference between what's exciting and what's ready to be built on.",
	spectrumItems: [
		{
			badge: "Leading Edge",
			badgeTone: "lead",
			title: "Where We Build",
			body:
				"Reliable, tested, and genuinely useful. AI that solves a known problem with confidence. Proven in production. This is where we build your business.",
		},
		{
			badge: "Bleeding Edge",
			badgeTone: "bleed",
			title: "What We Watch",
			body:
				"Newest AI releases. Exciting capabilities. Unproven in real production environments. We stay informed so we know when something crosses the line into ready.",
		},
	],

	processTag: "Case Studies",
	processHeading: "How We Operate",
	processDesc: "AI is the engine. Your business is the destination. Our case studies stay focused on the problem, the strategy, and the result. This section explains how the work happens.",
	processSteps: [
		{
			marker: "01",
			heading: "Understand the Problem",
			body: "We begin with the business challenge, the customer need, and the desired outcome.",
		},
		{
			marker: "02",
			heading: "Build the Strategy",
			body: "We define the approach, priorities, and channel plan before selecting any supporting tools.",
		},
		{
			marker: "03",
			heading: "Execute With the Right Tools",
			body: "AI supports the work through better insight, improved efficiency, and faster optimization, while decisions stay human.",
		},
		{
			marker: "→",
			heading: "See the Results",
			body: "Review how this approach shows up in real client work across strategy, execution, and performance outcomes.",
		},
	],
	caseStudiesCta: { label: "View Case Studies", href: "/work" },

	contactTag: "Build with Agentic Commerce",
	contactHeadingLine1: "Ready to Solve a",
	contactHeadingAccent: "Real Problem?",
	contactDesc: "Drop your email and a Titan will reach out to learn about your business, not sell you on AI.",
	contactHubspot: {
		portalId: "544161",
		formId: "999b3383-c0df-4ee3-9936-7b033a5e7441",
		region: "na1",
	},
};

export default data;
